<template>
  <div class="schedule-calendar-week">
        <span v-for="wk in weeks"
              class="schedule-calendar-week-item">{{wk}}</span>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    //根据传入的startWeek，显示日历上方的星期是从周一开始还是周日开始
    props: {
      startWeek: Number
    },
    data() {
      return {
        cn: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      }
    },
    computed: {
      weeks() {
        //this.cn.splice(0, this.startWeek)方法会改变原始数组，因此此时cn的值为['一', '二', '三', '四', '五', '六'],this.cn.splice(0, this.startWeek)的值为['日']
        return this.startWeek === 0 ? this.cn : this.cn.concat(this.cn.splice(0, this.startWeek))
      }
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>

  .schedule-calendar-week {
    padding-bottom: 9px;
    height: 40px;
    .schedule-calendar-week-item {
      float: left;
      margin-right: 38px;
      font-size: 14px;
      color: #666;
      height: 40px;
      width: 40px;
      line-height: 40px;
      text-align: center
      &:last-child {
        margin-right: 0
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/calendarlist/timetable/calendar/week.vue